<!-- VERSION 1 - SUBTLE PROGRESS BAR -->
@if (loading) {
  <mat-progress-bar mode="indeterminate" color="primary" />
}

<!-- VERSION 2 - SPINNER WITH BACKGROUND COVER -->
<!-- <div class="progress-loader" [hidden]="!loading">
<div class="loading-spinner">
  <mat-spinner></mat-spinner>
  <span class="loading-message">Please wait...</span>
</div>
</div> -->